import {Association} from 'api/gen/Association';
import {BasicRole} from 'api/gen/BasicRole';
import {Breeder} from 'api/gen/Breeder';
import {Farm} from 'api/gen/Farm';
import {Organization} from 'api/gen/Organization';
import {OrganizationCenter} from 'api/gen/OrganizationCenter';
import {OtherSubject} from 'api/gen/OtherSubject';
import {Subject} from 'api/gen/Subject';

import {UserDetailLoadingId} from '../types/user-detail-loading-id';

/** Redux state stored for the user-detail feature. */
export interface UserDetailState {
    /** Current member-of-subjects row being edited. */
    memberOfSubjectsEditingId: number | null;
    /** Visibility flag for the member-of-subjects modal. */
    memberOfSubjectsModalVisible: boolean;
    /** Subject search options. */
    subjectOptions: Array<Subject>;
    /** Visibility flag for the user contacts modal. */
    userContactsModalVisible: boolean;
    /** Currently opened association modal row. */
    associationsModalVisible: string | null;
    /** Currently opened facility modal row. */
    facilityModalVisible: string | null;
    /** Association search options. */
    associationOptions: Array<Association>;
    /** Organization search options. */
    organizationOptions: Array<Organization>;
    /** Organization center search options. */
    centerOptions: Array<OrganizationCenter>;
    /** Other-subject role options. */
    otherSubjectRoleOptions: Array<BasicRole>;
    /** Association role options. */
    associationRoleOptions: Array<BasicRole>;
    /** Breeder role options. */
    breederRoleOptions: Array<BasicRole>;
    /** Organization role options. */
    organizationRoleOptions: Array<BasicRole>;
    /** Other-subject search options. */
    otherSubjectsOptions: Array<OtherSubject>;
    /** Breeder search options. */
    breederOptions: Array<Breeder>;
    /** Farm search options. */
    farmOptions: Array<Farm>;
    /** Organization farm search options. */
    organizationFarmOptions: Array<Farm>;
    /** Active async loading markers. */
    loading: Array<UserDetailLoadingId>;
}

/** Initial Redux state for the user-detail feature. */
export const initialUserDetailState: UserDetailState = {
    facilityModalVisible: null,
    memberOfSubjectsEditingId: null,
    memberOfSubjectsModalVisible: false,
    subjectOptions: [],
    associationOptions: [],
    userContactsModalVisible: false,
    associationsModalVisible: null,
    organizationOptions: [],
    centerOptions: [],
    otherSubjectRoleOptions: [],
    associationRoleOptions: [],
    breederRoleOptions: [],
    organizationRoleOptions: [],
    otherSubjectsOptions: [],
    breederOptions: [],
    farmOptions: [],
    loading: [],
    organizationFarmOptions: [],
};
